
/**
 * 트윗 유형
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType = typeof ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType[keyof typeof ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
